import {Hal} from './hal.model';

export class CommentHal extends Hal {
  identification: string;
  content: string;
  authorId: string;
  authorName: string;
  createdAt: string;
  updatedAt: string;

  constructor(data: any) {
    super(data);
    this.identification = data.identification;
    this.content = data.content;
    this.authorId = data.authorId;
    this.authorName = data.authorName;
    this.createdAt = data.createdAt;
    this.updatedAt = data.updatedAt;
  }
}

export class CommentCollectionHal extends Hal {
  _embedded?: { comments: CommentHal[] };

  constructor(data: any) {
    super(data);
    if (data._embedded?.comments) {
      this._embedded = {
        comments: data._embedded.comments.map((c: any) => new CommentHal(c))
      };
    }
  }
}

